// extracted by mini-css-extract-plugin
module.exports = {"ad-slot":"topAd-m__ad-slot__38cWv","hide-top":"topAd-m__hide-top__2dnbm"};